import { render, staticRenderFns } from "./AdvanceInfo.vue?vue&type=template&id=60e2a37b&"
import script from "./AdvanceInfo.vue?vue&type=script&lang=js&"
export * from "./AdvanceInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports